// ── Timezones with friendly labels ───────────────────────────────────────────
export const TIMEZONES = [
  { value: 'UTC',                   label: 'UTC — Coordinated Universal Time' },
  { value: 'America/New_York',      label: 'Eastern (ET) — New York, Miami' },
  { value: 'America/Chicago',       label: 'Central (CT) — Chicago, Dallas' },
  { value: 'America/Denver',        label: 'Mountain (MT) — Denver, Phoenix' },
  { value: 'America/Los_Angeles',   label: 'Pacific (PT) — Los Angeles, Seattle' },
  { value: 'America/Anchorage',     label: 'Alaska (AKT) — Anchorage' },
  { value: 'Pacific/Honolulu',      label: 'Hawaii (HT) — Honolulu' },
  { value: 'America/Sao_Paulo',     label: 'Brasília (BRT) — São Paulo, Rio' },
  { value: 'America/Toronto',       label: 'Eastern Canada — Toronto' },
  { value: 'America/Vancouver',     label: 'Pacific Canada — Vancouver' },
  { value: 'Europe/London',         label: 'GMT/BST — London, Dublin' },
  { value: 'Europe/Paris',          label: 'Central European (CET) — Paris, Rome, Madrid' },
  { value: 'Europe/Berlin',         label: 'Central European (CET) — Berlin, Amsterdam' },
  { value: 'Europe/Helsinki',       label: 'Eastern European (EET) — Helsinki, Kyiv' },
  { value: 'Europe/Moscow',         label: 'Moscow (MSK) — Moscow' },
  { value: 'Asia/Dubai',            label: 'Gulf (GST) — Dubai, Abu Dhabi' },
  { value: 'Asia/Kolkata',          label: 'India (IST) — Mumbai, Delhi, Bangalore' },
  { value: 'Asia/Bangkok',          label: 'Indochina (ICT) — Bangkok, Jakarta' },
  { value: 'Asia/Singapore',        label: 'Singapore (SGT) — Singapore, Kuala Lumpur' },
  { value: 'Asia/Shanghai',         label: 'China (CST) — Beijing, Shanghai' },
  { value: 'Asia/Tokyo',            label: 'Japan (JST) — Tokyo, Osaka' },
  { value: 'Asia/Seoul',            label: 'Korea (KST) — Seoul' },
  { value: 'Australia/Sydney',      label: 'AEDT — Sydney, Melbourne' },
  { value: 'Australia/Perth',       label: 'AWST — Perth' },
  { value: 'Pacific/Auckland',      label: 'NZDT — Auckland, Wellington' },
];

export const DAYS_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const DAYS_FULL  = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

export const CATEGORIES = [
  { id: 'daily',        label: 'Daily',                  desc: 'Every day or weekdays only' },
  { id: 'several_week', label: 'Several times a week',   desc: 'M/W/F, Tu/Th, M/W, or W/F' },
  { id: 'weekly',       label: 'Weekly',                 desc: 'A specific day each week' },
  { id: 'several_month',label: 'Several times a month',  desc: 'A day on the 1st & 3rd or 2nd & 4th weeks of a month' },
  { id: 'monthly',      label: 'Monthly',                desc: 'A day on a specific week each month' },
];

export function generateRows(category) {
  switch (category) {
    case 'daily':
      return [
        { id: 'daily_all',      label: 'Every day (Sun–Sat)',    days: [0,1,2,3,4,5,6] },
        { id: 'daily_weekdays', label: 'Weekdays only (Mon–Fri)',days: [1,2,3,4,5] },
      ];

    case 'several_week':
      return [
        { id: 'mwf', label: 'Mon / Wed / Fri', days: [1,3,5] },
        { id: 'tth', label: 'Tue / Thu',        days: [2,4] },
        { id: 'mw',  label: 'Mon / Wed',        days: [1,3] },
        { id: 'wf',  label: 'Wed / Fri',        days: [3,5] },
      ];

    case 'weekly':
      return DAYS_FULL.map((d, i) => ({
        id: 'w' + i,
        label: 'Every ' + d,
        days: [i],
      }));

    case 'several_month': {
      const rows = [];
      for (let di = 0; di < 7; di++) {
        rows.push({ id: 'sm13_' + di, label: '1st & 3rd ' + DAYS_FULL[di], days: [di], nth: [1, 3] });
        rows.push({ id: 'sm24_' + di, label: '2nd & 4th ' + DAYS_FULL[di], days: [di], nth: [2, 4] });
      }
      return rows;
    }

    case 'monthly': {
      const rows = [];
      const labels = ['1st','2nd','3rd','4th','Last'];
      const nths   = [1, 2, 3, 4, -1];
      for (let n = 0; n < 5; n++) {
        for (let di = 0; di < 7; di++) {
          rows.push({ id: 'm' + n + '_' + di, label: labels[n] + ' ' + DAYS_FULL[di], days: [di], nth: [nths[n]] });
        }
      }
      return rows;
    }

    default:
      return [];
  }
}

export function getActiveDaysForRow(row, year, month) {
  const active = new Set();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  if (!row.nth) {
    for (let d = 1; d <= daysInMonth; d++) {
      if (row.days.includes(new Date(year, month, d).getDay())) active.add(d);
    }
  } else {
    const byDow = {};
    for (let d = 1; d <= daysInMonth; d++) {
      const dow = new Date(year, month, d).getDay();
      if (!byDow[dow]) byDow[dow] = [];
      byDow[dow].push(d);
    }
    row.days.forEach(function(dow) {
      const arr = byDow[dow] || [];
      row.nth.forEach(function(n) {
        if (n === -1) { if (arr.length) active.add(arr[arr.length - 1]); }
        else          { if (arr[n - 1] !== undefined) active.add(arr[n - 1]); }
      });
    });
  }
  return active;
}

export function generateTimes(granularity) {
  granularity = granularity || 60;
  const times = [];
  for (let h = 0; h < 24; h++) {
    times.push(String(h).padStart(2,'0') + ':00');
    if (granularity === 30) times.push(String(h).padStart(2,'0') + ':30');
  }
  return times;
}

export function formatTime(timeStr, use12h) {
  if (use12h === undefined) use12h = true;
  if (!use12h) return timeStr;
  const parts = timeStr.split(':').map(Number);
  const h = parts[0], m = parts[1];
  const period = h < 12 ? 'AM' : 'PM';
  const h12    = h % 12 === 0 ? 12 : h % 12;
  return String(h12).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ' ' + period;
}

export function isBusinessHour(timeStr) {
  const h = parseInt(timeStr.split(':')[0], 10);
  return h >= 8 && h < 17;
}

export function convertTime(timeStr, fromTz, toTz) {
  try {
    const parts = timeStr.split(':').map(Number);
    const h = parts[0], m = parts[1];
    const ref = new Date(Date.UTC(2024, 0, 7, h, m));

    const toOffset   = getUtcOffsetMinutes(toTz,   ref);
    const fromOffset = getUtcOffsetMinutes(fromTz,  ref);
    const diffMins   = toOffset - fromOffset;

    const totalMins = h * 60 + m + diffMins;
    const newH = ((Math.floor(totalMins / 60)) % 24 + 24) % 24;
    const newM = ((totalMins % 60) + 60) % 60;
    const dayShift = totalMins < 0 ? -1 : totalMins >= 1440 ? 1 : 0;

    return {
      time: String(newH).padStart(2,'0') + ':' + String(newM).padStart(2,'0'),
      dayShift: dayShift,
    };
  } catch(e) {
    return { time: timeStr, dayShift: 0 };
  }
}

function getUtcOffsetMinutes(tz, date) {
  const utcStr = date.toLocaleString('en-US', { timeZone: 'UTC' });
  const tzStr  = date.toLocaleString('en-US', { timeZone: tz });
  return (new Date(tzStr) - new Date(utcStr)) / 60000;
}
